
export const API_URL     = 'https://dev-api.smaki.com.ua';
export const API_PREFIX  = 'api';
export const NODE_ENV    = 'PROD';
export const CRM_VERSION = '2.14.11';

